"use client";

import { c as _c } from "react/compiler-runtime";
import { api } from "@agroproj/backend/convex/_generated/api";
import { useQuery } from "convex/react";
import { Plus } from "lucide-react";
import { useParams } from "next/navigation";
import { AssistantInsights } from "@/components/assistant/assistant-insights";
import { DashboardOverview } from "@/components/dashboard/dashboard-overview";
import { FinancialSummary } from "@/components/dashboard/financial-summary";
import { RecentActivity } from "@/components/dashboard/recent-activity";
import { PageWrapper } from "@/components/page-wrapper";
import { ButtonLink } from "@/components/ui/button";
import { SectionStack } from "@/components/ui/section";
export default function OrganizationDashboardPage() {
  const $ = _c(17);
  const {
    organizationSlug
  } = useParams();
  const organizationStatus = useQuery(api.check_membership.hasOrganization);
  const isSubscriptionLocked = organizationStatus?.hasActiveSubscription !== true;
  let t0;
  if ($[0] !== organizationSlug) {
    t0 = organizationSlug ? <ButtonLink size="sm" href={`/${organizationSlug}/projects/new`}><Plus />Novo projeto</ButtonLink> : null;
    $[0] = organizationSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const actions = t0;
  let t1;
  if ($[2] !== isSubscriptionLocked || $[3] !== organizationSlug) {
    t1 = !isSubscriptionLocked ? <AssistantInsights organizationSlug={organizationSlug} /> : null;
    $[2] = isSubscriptionLocked;
    $[3] = organizationSlug;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  let t3;
  let t4;
  if ($[5] !== isSubscriptionLocked) {
    t2 = <DashboardOverview subscriptionLocked={isSubscriptionLocked} />;
    t3 = <FinancialSummary subscriptionLocked={isSubscriptionLocked} />;
    t4 = <RecentActivity subscriptionLocked={isSubscriptionLocked} />;
    $[5] = isSubscriptionLocked;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <SectionStack>{t1}{t2}{t3}{t4}</SectionStack>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== actions || $[15] !== t5) {
    t6 = <PageWrapper actions={actions} title="Dashboard">{t5}</PageWrapper>;
    $[14] = actions;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}